<template lang="pug">
  .container
    vm-row.router(vm-w="12")
      vm-col(vm-type="flex" vm-align="center" vm-lg=6 vm-sm=6)
        router-link(:to="{name: 'finished'}")
          vm-button(icon="arrow-back-outline" radius)
    vm-row(vm-w="12")
      vm-col(vm-sm=12)
        payments

</template>
<script>
export default {
  name: 'PaymentsFinisheds',
  components: {
    Payments: () => import('@/components/in-order/Payments.vue')
  },
  data: () => ({
  })
}
</script>
<style lang="scss" scoped>
.router {
  margin: 10px 20px 0px 20px;
}
.container {
  margin: 40px;
  background: white;
  padding: 10px;
  border-radius: 5px;
  box-shadow: 5px 5px 25px 0 rgba(46,61,73,.11);
}
</style>
